import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import React, { useMemo } from 'react';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { residualValueGridsStore } from '../store';
import { RESIDUAL_VALUE_GRIDS } from '../../queries';
import { CollectionType } from '@ts-private/list-browser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import ItemComponent from './ItemComponent';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { GENERIC_ENTITY_BUSINESS_STATES_QUERY } from 'features/genericEntityFlow/list/queries';
import { RESIDUAL_VALUE_GRID_DELETED, RESIDUAL_VALUE_GRID_DUPLICATED } from 'features/residualValueGrid/subscriptions';
import useSubscription from 'hooks/apollo/useSubscription';
import { useTranslation } from 'react-i18next';
import { useToast } from 'hooks/toasts/useToast';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import useConfirmDialog from 'features/common/components/confirm/useConfirmDialog';

const BrowserComponent = () => {
  const { t } = useTranslation();
  const addToast = useToast();
  const historyContext = useHistoryWithContext();
  const confirm = useConfirmDialog();

  // #region Subscriptions

  useSubscription(RESIDUAL_VALUE_GRID_DELETED, {
    onData: ({ client }) => {
      addToast(t('ResidualValueGrid.Deleted'), 'success');
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'residualValueGrids' });
    }
  });

  useSubscription(RESIDUAL_VALUE_GRID_DUPLICATED, {
    onData: ({ client, data }) => {
      addToast(t('ResidualValueGrid.Duplicated'), 'success');
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'residualValueGrids' });
      confirm(
        () => {
          historyContext.push(`/residualValueGrids/${data.data.residualValueGridDuplicated.id}`);
        },
        {
          content: t('ResidualValueGrid.NavigateToDuplicate')
        }
      );
    }
  });

  // #endregion

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: RESIDUAL_VALUE_GRIDS,
        name: 'residualValueGrids'
      },
      collectionsOptions: [
        {
          queryOptions: { query: GENERIC_ENTITY_BUSINESS_STATES_QUERY },
          name: 'genericEntityBusinessStates',
          identifier: 'stateId',
          collectionType: CollectionType.Filter,
          valueKey: 'stateId',
          labelKey: 'stateName'
        }
      ]
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'code', caption: 'ResidualValueGrid.Code', width: '15%' },
      { name: 'name', caption: 'ResidualValueGrid.Name' },
      { name: 'fromDate', caption: 'ResidualValueGrid.FromDate', width: '15%' },
      { name: 'toDate', caption: 'ResidualValueGrid.ToDate', width: '15%' },
      { name: 'isActive', caption: 'ResidualValueGrid.IsActive', align: 'center', width: '10%' },
      { name: 'state', caption: 'ResidualValueGrid.State', width: '12%' },
      { name: 'actions', caption: 'Actions', width: '120px' }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser store={residualValueGridsStore} ItemComponent={ItemComponent} columns={columns} />
      <ExportModalComponent store={residualValueGridsStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={residualValueGridsStore} options={fetchingOptions} />
    </Card>
  );
};

export default BrowserComponent;
